import React, { useContext, useEffect } from "react";
import Heading from "@amzn/meridian/heading";
import Text from "@amzn/meridian/text";
import { CycleFilterContext } from "../overview/context/CycleFilterContext";
import { OverviewContext } from "../overview/context/OverviewContext";
import { FormattedMessage, injectIntl } from "react-intl";
import Row from "@amzn/meridian/row";
import Tooltip from "@amzn/meridian/tooltip";
import Box from "@amzn/meridian/box";
import infoKnockoutTokens from "@amzn/meridian-tokens/base/icon/info-knockout";
import Icon from "@amzn/meridian/icon";
import { PVAOverviewContext } from "../overview/context/PVAOverviewContext";
import { getTotalInboundPackageVolumeByCycle } from "../overview/utils/utils";

const TVView = (props) => {
  const { cycles } = useContext(CycleFilterContext);
  const { viewModel, dispatch } = useContext(OverviewContext);
  const { pvaData } = useContext(PVAOverviewContext);

  const getTVData = () => {
    dispatch({
      type: "LOAD_ARRIVED_DATA",
      data: { filter: cycles, dispatcher: dispatch },
    });
  };

  useEffect(() => {
    if (cycles.allCycles.length > 0) {
      getTVData();
      const interval = setInterval(() => {
        if (!document.hidden) {
          getTVData();
        }
      }, props.tv.refreshRate);
      return () => clearInterval(interval);
    }
  }, [cycles]);

  const getPlannedVolumeForCycle = () => {
    if (
      !pvaData.dynamicShiftPlans.latest ||
      !cycles ||
      !cycles.selectedCycles
    ) {
      return "N/A";
    }
    const totalVolumeByCycle = getTotalInboundPackageVolumeByCycle(
      pvaData.dynamicShiftPlans.latest.input,
      cycles.allCycles,
    );
    return totalVolumeByCycle
      ? totalVolumeByCycle[cycles.selectedCycles[0]]
      : "N/A";
  };

  return (
    <Box type="outline" spacingInset="400">
      <div>
        <div className="overview-fph">
          <Heading level={2} type="h300" alignment="left">
            <FormattedMessage
              id={viewModel.tv[props.tv.processName].title}
              defaultMessage={viewModel.tv[props.tv.processName].defaultMessage}
            />
            <Tooltip
              position="right"
              title={props.intl.formatMessage({
                id: viewModel.tv[props.tv.processName].tooltip,
                defaultMessage:
                  viewModel.tv[props.tv.processName].tooltipMessage,
              })}
            >
              <Icon className={"custom-tool-tip"} tokens={infoKnockoutTokens} />
            </Tooltip>
          </Heading>
        </div>
        <Row width="100%" widths={["grid-4", "grid-4", "grid-4"]}>
          <div>
            <Text type="b100">
              <FormattedMessage id="hc.planned" defaultMessage="Planned" />
            </Text>
            <Text type="d50">{getPlannedVolumeForCycle()}</Text>
          </div>
          <div>
            <Text type="b100">
              <FormattedMessage id="tv.arrived" defaultMessage="Arrived" />
            </Text>
            <Text type="d50">{viewModel.tv.totalVolume.arrived}</Text>
          </div>
          <div>
            <Text type="b100">
              <FormattedMessage id="tv.inducted" defaultMessage="Inducted" />
            </Text>
            <Text type="d50">
              {!pvaData.overviewData.flowPVAData
                ? 0
                : pvaData.overviewData.flowPVAData["cumulative_15"][0]
                      .dataPointList.length === 0
                  ? 0
                  : pvaData.overviewData.flowPVAData["cumulative_15"][0]
                      .dataPointList[
                      pvaData.overviewData.flowPVAData["cumulative_15"][0]
                        .dataPointList.length - 1
                    ].metricValue}
            </Text>
          </div>
        </Row>
      </div>
    </Box>
  );
};

export default injectIntl(TVView);



// WEBPACK FOOTER //
// ./src/components/WIP/TVViewV2.js